export const ALERT_MODAL_DESCRIPTION =
  'La información se guardará. Asegúrate de llenar todos los campos obligatorios para completar el proceso';
export const SUCCESS_MODAL_TITLE = 'Información guardada con éxito';
export const REHIRE_ERROR_MODAL_TITLE = 'Error al intentar recontratar al empleado';
export const CREATE_ON_CRECI_ERROR_MODAL_TITLE = 'Error al intentar crear el usuario en Creci';
export const IN_PROGRESS_MODAL_TITLE = 'Guardando información';
